// Utilitaires partagés : lecture de config, formats FR, valeurs dérivées, préférences.
import { config } from "./ma-js-config.js?v=9dbd173928";

export const TBC = "[À CONFIRMER]";

/** Lit une valeur par chemin « a.b.c ». Retourne null si absente. */
export function get(path, obj = config) {
  const v = path.split(".").reduce((o, k) => (o == null ? undefined : o[k]), obj);
  return v === undefined ? null : v;
}

export const isSet = (v) => v !== null && v !== undefined && v !== false && v !== "";

const euro = new Intl.NumberFormat("fr-FR", { style: "currency", currency: "EUR" });
const euroRound = new Intl.NumberFormat("fr-FR", { style: "currency", currency: "EUR", maximumFractionDigits: 0 });
const intFr = new Intl.NumberFormat("fr-FR");

/** Prix FR. Entier affiché sans centimes (« 15 € ») sauf si cents = true (« 11,00 € »). */
export function formatPrice(n, cents = false) {
  if (!isSet(n)) return null;
  return Number.isInteger(n) && !cents ? euroRound.format(n) : euro.format(n);
}

export function formatDate(iso, opts = { day: "numeric", month: "long" }) {
  if (!isSet(iso)) return null;
  const d = new Date(iso.length === 10 ? `${iso}T12:00:00` : iso);
  return new Intl.DateTimeFormat("fr-FR", opts).format(d);
}

export const formatInt = (n) => (isSet(n) ? intFr.format(n) : null);

// 53.2 : dateShort = « 17/11/2026 »
export const FORMATS = { price: formatPrice, date: formatDate, int: formatInt, text: (v) => (isSet(v) ? String(v) : null),
  dateShort: (iso) => formatDate(iso, { day: "2-digit", month: "2-digit", year: "numeric", timeZone: "Europe/Paris" }) };

/** Valeurs dérivées de la config — toutes null si une donnée source manque. */
export const derived = {
  get gaugePercent() {
    const { lampsTotal: t, lampsReserved: r, lampsReservedIsTest: test } = config.scarcity;
    if (!isSet(t) || !isSet(r) || t <= 0) return null;
    // Valeur de test (préprod) : jamais affichée sur un hôte de prod, même si un export de préprod y était envoyé (§6).
    if (test && (config.tracking.hosts || []).includes(location.hostname)) return null;
    return Math.min(100, Math.round((r / t) * 100));
  },
  get membersVisible() {
    const { count, minToDisplay } = config.members;
    return isSet(count) && count >= minToDisplay;
  },
  get limitedStock() {
    return config.scarcity.showLimitedStock === true;
  },
  // 52.1 : la phase du compte à rebours — { kind: "vip" | "end", end: ms } ou null (rien d'affiché)
  get countdown() {
    const now = Date.now();
    const { vipEnd, offerEnd } = config.dates;
    if (isSet(vipEnd) && new Date(vipEnd).getTime() > now) return { kind: "vip", end: new Date(vipEnd).getTime() };
    const days = config.countdown?.lastDays;
    if (!isSet(offerEnd) || !isSet(days)) return null;
    const end = new Date(offerEnd).getTime();
    return end > now && end - now <= days * 86400000 ? { kind: "end", end } : null;
  },
  get countdownActive() {
    return derived.countdown !== null;
  },
  get noCommitment() {
    return isSet(config.guarantees.cancelOneClick);
  },
  get maxFreeMonths() {
    const m = Math.max(0, ...config.plans.map((p) => p.freeMonths || 0));
    return m > 0 ? m : null;
  },
  get trustVisible() {
    const t = config.trust;
    return isSet(t.families) || (isSet(t.rating) && isSet(t.reviewsCount));
  }
};

/** Prix calculés d'une formule : total (confirmé ou indicatif), par mois, économie. */
export function planPricing(plan, monthly = config.pricing.monthly) {
  const full = plan.months * monthly;
  const confirmed = isSet(plan.total);
  const total = confirmed ? plan.total : (plan.months - plan.freeMonths) * monthly;
  return {
    confirmed,
    full: Math.round(full * 100) / 100,     // prix de référence (barré) : prix mensuel sans engagement × durée
    total: Math.round(total * 100) / 100,
    perMonth: Math.round((total / plan.months) * 100) / 100,
    saving: Math.round((full - total) * 100) / 100
  };
}

export const prefersReducedMotion = () =>
  window.matchMedia("(prefers-reduced-motion: reduce)").matches;

export const $ = (sel, root = document) => root.querySelector(sel);
export const $$ = (sel, root = document) => [...root.querySelectorAll(sel)];
